import React from 'react';
import Header from '../../Header';
import icon_ios from '../../../../pictures/upto15s/iOS/icon.png';
import icon_and from '../../../../pictures/upto15s/Android/icon.png';

const PrivacyPolicy = () => {
  return(
    <div>
    <div className='ui container'>
      <Header currentPage='sitsaPP' />
    </div>
    {buildContent()}
    </div>
  )
}

const buildContent = () => {
  return(
    <div>
      <h1>Privacy Policy</h1>
			<p className="privacy-policy-app-body">
	      <p>
	        This is the privacy Policy for the Stick in the Sand Apps.
	      </p>
	      <p className="bulleted">
					<span>
					‣ NO information collected or generated in the apps is used
					anywhere else for anything other than help to the users of the app on
					the local device on which the information is collected unless specified
					in the specific privacy policy of the app outlined below.
					</span>
				</p>
				<p className="bulleted">
					<span>
					‣ The only foreseeable reason for a change is to provide online
					reports of progress in the future, or information is needed for troubleshooting.
					</span>
				</p>
			</p>
			<div>
				<strong className="privacy-policy-subtitle">Privacy Policy for <span className="app-title">Up To 15s</span></strong>
				<div>
					<img className="privacy-policy-app-icon" src={icon_ios} alt="Up To 15s iOS icon" />
					<img className="privacy-policy-app-icon" src={icon_and} alt="Up To 15s Android icon" />
				</div>
				<p className="privacy-policy-app-body">
					<p className="section">
						<p>
							Stick in the Sand Apps built the Up To 15s app as a Commercial app. This SERVICE is provided by Stick in the Sand Apps  and is intended for use as is.
						</p>
						<p>
							This page is used to inform visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service.
						</p>
						<p>
							If you choose to use our Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that we collect is used for providing and improving the Service. we will not use or share your information with anyone except as described in this Privacy Policy.
						</p>
						<p>
							The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at <a href="../TermsAndConditions">Terms and Conditions</a> unless otherwise defined in this Privacy Policy.
						</p>
					</p>
					<p className="section-title">
						<strong>Information Collection and Use</strong>
					</p>
					<p className="section">
						<p>
							For a better experience, while using our Service, we may require you to provide us with certain personally identifiable information. The information that we request will be retained by us and used as described in this privacy policy.
						</p>
					</p>
					<p className="section-title">
						<strong>Log Data</strong>
					</p>
					<p className="section">
						we want to inform you that whenever you use our Service, in a case of an error in the app we collect data and information (through third party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol (“IP”) address, device name, operating system version, the configuration of the app when utilizing our Service, the time and date of your use of the Service, and other statistics.
					</p>
					<p className="section-title">
						<strong>Cookies</strong>
					</p>
					<p className="section">
						<p>
							Cookies are files with a small amount of data that are commonly used as anonymous unique identifiers. These are sent to your browser from the websites that you visit and are stored on your device's internal memory.
						</p>
						<p>
							This Service does not use these “cookies” explicitly. However, the app may use third party code and libraries that use “cookies” to collect information and improve their services. You have the option to either accept or refuse these cookies and know when a cookie is being sent to your device. If you choose to refuse our cookies, you may not be able to use some portions of this Service.
						</p>
					</p>
					<p className="section-title">
						<strong>Service Providers</strong>
					</p>
					<p className="section">
						<p>
							We may employ third-party companies and individuals due to the following reasons:
						</p>
							<ul>
								<li>To facilitate our Service;</li>
								<li>To provide the Service on our behalf;</li>
								<li>To perform Service-related services; or</li>
								<li>To assist us in analyzing how our Service is used.</li>
							</ul>
						<p>
							We want to inform users of this Service that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.
						</p>
					</p>
					<p className="section-title">
						<strong>Security</strong>
					</p>
					<p className="section">
						We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.
					</p>
					<p className="section-title">
						<strong>Links to Other Sites</strong>
					</p>
					<p className="section">
						This Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. we have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.
					</p>
					<p className="section-title">
						<strong>Children’s Privacy</strong>
					</p>
					<p className="section">
						These Services do not address anyone under the age of 13. we do not knowingly collect personally identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do necessary actions.
					</p>
					<p className="section-title">
						<strong>Changes to This Privacy Policy</strong>
					</p>
					<p className="section">
						<p>
							We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. we will notify you of any changes by posting the new Privacy Policy on this page.
						</p>
						<p>
							This policy is effective as of 2020-05-05
						</p>
					</p>
					<p className="section-title">
						<strong>Contact Us</strong>
					</p>
					<p className="section">
						<p>
							If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at <a href="mailto:jmlathamllc@yahoo.com">jmlathamllc@yahoo.com</a>.
						</p>
						<p>
							This privacy policy page was created at <a href="https://privacypolicytemplate.net" target="_blank" rel="noopener noreferrer">privacypolicytemplate.net</a> and modified/generated by <a href="https://app-privacy-policy-generator.firebaseapp.com/" target="_blank" rel="noopener noreferrer">App Privacy Policy Generator</a>
						</p>
					</p>
				</p>
			</div>
    </div>
  );
}

export default PrivacyPolicy;
